var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveUpMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Send_up_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M13.124 4.125v15.749a1.125 1.125 0 11-2.249 0V4.125a1.125 1.125 0 112.249 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 5",
    d: "M16.938 7.955a1.125 1.125 0 01-1.922.794L11.999 5.72 8.983 8.749A1.125 1.125 0 117.39 7.162l3.812-3.83a1.125 1.125 0 011.594 0l3.814 3.83a1.121 1.121 0 01.328.793z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15111",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgMoveUpMobile;